<template>
  <div class="tasks-list">
    <span v-for="(task, id) in tasks" v-bind:key="id" :class="task.status" class="rows justify-space-between">
      →&nbsp;{{ task.text }}
      <i :class="taskIconByStatus(task.status)" class="bi"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'TaskList',
  props: {
    tasks: Object,
  },
  methods: {
    taskIconByStatus(status) {
      switch (status) {
        case 'fail':
          return 'bi-x';
        case 'success':
          return 'bi-check';
        default:
          return 'bi-three-dots';
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.tasks-list {
  span {
    i {
      font-size: 1.4em;
    }

    &.pending i {
      color: $neutral-field-color;
    }

    &.fail i {
      color: $dirty-field-color;
    }

    &.success i {
      color: $success-field-color;
    }
  }
}
</style>
